import { matchPath, NavigationType } from "react-router";

import useBlockNavigationModal from "hooks/useBlockNavigationModal";

import { ASSISTANT_PAGE_ROUTE } from "../../constants";
import {
  STOP_RUNNING_CHAT_CONFIRMATION_LABEL,
  STOP_RUNNING_CHAT_DESCRIPTION,
  STOP_RUNNING_CHAT_TITLE,
} from "../constants";
import { isChatStatusBusy } from "../helpers";
import useChatStore from "../store/useStore";

// Page only: React Router runs one blocker at a time, so in the drawer it shadows form blockers.
const useAssistantPanelRunningChatBlocker = () => {
  useBlockNavigationModal({
    isNavigationBlocked: true,
    shouldBlock: ({ historyAction, nextLocation }) =>
      historyAction === NavigationType.Pop &&
      !!matchPath(ASSISTANT_PAGE_ROUTE, nextLocation.pathname) &&
      isChatStatusBusy(useChatStore.getState().chat?.status),
    title: STOP_RUNNING_CHAT_TITLE,
    description: STOP_RUNNING_CHAT_DESCRIPTION,
    confirmationButtonLabel: STOP_RUNNING_CHAT_CONFIRMATION_LABEL,
  });
};

export default useAssistantPanelRunningChatBlocker;
